/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import * as _ from 'lodash';

import BUILD_INFO from '../../../gen-config/build-info';
import {getRegisteredUrl} from '../../config/registered-urls';
import template from './nude-shell-layout.html';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {WINDOW} from '../../angular-platform-providers';

@Component({
  standalone: false,
  selector: 'adn-nude-shell-layout',
  template
})
export class NudeShellLayoutComponent {
  uiLogo: string;
  releaseId: string;

  constructor(
    @Inject(WINDOW) window: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    const regUrl = getRegisteredUrl(window, LocalNetworkProfile.get('networkId'));
    this.uiLogo = _.get(regUrl, ['logo']) || LocalNetworkProfile.get('adnUiLogo');
    this.releaseId = BUILD_INFO.gitSha.substring(0, 10);
  }
}
